// extracted by mini-css-extract-plugin
module.exports = {"container":"PdfViewer_container__19jck","spinner":"PdfViewer_spinner__3w7Wh","document":"PdfViewer_document__dchKy"};